import React, { useCallback } from 'react';
import { path } from 'ramda';

import { ContactInfoUpdate } from './components/ContactInfoUpdate';

import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';

import { useTranslations } from 'js/hooks/i18n';
import { storageService } from 'js/services/storage.service';
import { useUserSelector } from 'js/store/hooks';

import style from './ContactInfoUpdatePopup.scss';

export const ContactInfoUpdatePopup = ({ id, onClose, terms, isSetToLocalStorage }) => {
    const t = useTranslations('playtech.mobile.system.enter-draw.contact-popup.');
    const playerCode = useUserSelector(path(['userDetails', 'playerCode']));
    const onClosePopup = useOnClose(id);

    const handleClosePopup = useCallback(async () => {
        if (isSetToLocalStorage) {
            storageService.local.setItem(`contactInfoChecked_${playerCode}`, 1);
        }

        if (onClose) {
            await onClose();
        }

        onClosePopup();
    }, [isSetToLocalStorage, onClose, onClosePopup, playerCode]);

    return (
        <ManagedPopup
            className={style.container}
            onClose={onClosePopup}
            title={t('title')}
        >
            <ContactInfoUpdate
                terms={terms}
                closePopup={handleClosePopup}
            />
        </ManagedPopup>
    );
};
